// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"9a1b3123","453":"46dc3e92","601":"2d99c62b","888":"2c415272"}[chunkId] + ".chunk.js";
};